import { Navigation } from '../ReactCalendar';
import { nextWeek, prevWeek } from './utils';
import {
  ArrowLeftLargeIcon,
  ArrowRightLargeIcon,
  CalendarIcon,
} from '@keyslabor/shared/assets';
import { Flex, Text } from '@keyslabor/shared/ui';
import Grid from '@keyslabor/shared/ui/layout/Grid';
import { navBarStyles } from './styles';
import { CalendarNavigationProps, NavType, TopDateType } from './types';
import Icon from '@keyslabor/shared/ui/Icon';
import useCalendarUtils from '@/hooks/useCalendarUtils.ts';
import { useCalendarConfig } from '@/hooks/useCalendarConfig.ts';
import { substituteWeekNumberInFormattedString } from '@/utils/calendarUtils.ts';

export default function CalendarNavigation({
  value,
  height,
  onDateSelect,
  onNavClick,
  withCalendarIcon = true,
  weekSelect,
  topDateType,
  position = 'bottom',
  disableNext,
  disablePrev,
  navType,
}: CalendarNavigationProps) {
  const utils = useCalendarUtils();
  const calendarConfig = useCalendarConfig();
  const { curWeek, year } = utils.getFormattedDateNames(value);
  //console.log('CalendarNavigation', { curWeek, year, value });
  return (
    <Grid
      css={[navBarStyles(position)]}
      gridAutoFlow="column"
      justifyContent="space-around"
      gap={position === 'bottom' ? '20px' : '0px'}
    >
      {/* <Link
        kind="icon"
        onClick={() => {
          if (disablePrev) return;
          onDateSelect(prevWeek(value));
        }}
      >
        <Icon ml="3px" pathFillColor="#569DE5">
          <ArrowLeftLargeIcon />
        </Icon>
      </Link> */}
      <Flex
        alignItems={'center'}
        onClick={() => {
          if (disablePrev) return;
          onDateSelect(prevWeek(value));
        }}
      >
        <Icon ml="3px" pathFillColor="#569DE5">
          <ArrowLeftLargeIcon />
        </Icon>
      </Flex>
      <Flex alignItems="center" onClick={onNavClick}>
        <Navigation
          navigationLabel={() => {
            return (
              <Flex alignItems={'center'} height={height}>
                <Text
                  mt="2px"
                  fontSize={navType === NavType.Ribbon ? '14px' : '16px'}
                  lineHeight={'14px'}
                >
                  {substituteWeekNumberInFormattedString(
                    weekSelect || topDateType === TopDateType.Week
                      ? `Week ${curWeek}, ${year}`
                      : `${utils.getNiceDate(value)}, ${year}`,
                    calendarConfig.weeksOffset
                  )}
                </Text>
                {withCalendarIcon && (
                  <Text ml="10px" display="flex">
                    <CalendarIcon />
                  </Text>
                )}
              </Flex>
            );
          }}
          nextLabel={null}
          prevLabel={null}
          key={`${Math.random()}-${value?.valueOf()}`}
          next2Label={null}
          prev2Label={null}
          activeStartDate={value}
          drillUp={() => null}
          view="month"
          views={['month']}
          setActiveStartDate={onDateSelect}
        />
      </Flex>
      <Flex
        alignItems={'center'}
        onClick={() => {
          if (disableNext) return;
          onDateSelect(nextWeek(value));
        }}
      >
        <Icon pathFillColor="#569DE5">
          <ArrowRightLargeIcon />
        </Icon>
      </Flex>
    </Grid>
  );
}
